import axios from "axios";
import { API } from "./brand";

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Prevent concurrent refresh storms — share a single in-flight refresh promise
let refreshPromise = null;

function shouldSkipRefresh(url) {
    if (!url) return false;
    return (
        url.includes("/auth/login") ||
        url.includes("/auth/refresh") ||
        url.includes("/auth/logout") ||
        url.includes("/auth/me")
    );
}

api.interceptors.response.use(
    (res) => res,
    async (error) => {
        const { config, response } = error;
        if (!response || response.status !== 401) return Promise.reject(error);
        if (!config || config._retried) return Promise.reject(error);
        if (shouldSkipRefresh(config.url)) return Promise.reject(error);

        config._retried = true;
        try {
            if (!refreshPromise) {
                refreshPromise = api.post("/auth/refresh").finally(() => {
                    refreshPromise = null;
                });
            }
            await refreshPromise;
        } catch {
            return Promise.reject(error);
        }
        return api(config);
    }
);

export default api;
